// import logoLabeler from '@Cyclope-Assets/images/logo/tunnelwatch.png';

import * as React from "react";
import * as i18next from "i18next";
import { Link } from "react-router-dom";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    onAddInhibition,
    authorizationInibition,
    message,
    links,
    visualizationCamera,
  } = props;
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <div className="maintenance animated fadeIn">
      <div className="ml_maintenance ">
        <div className="ml_clearRoad">
          <div className="message-empty-incident">
            <p>{message}</p>
            {authorizationInibition && (
              <div className="btn-explore">
                <p style={{ display: "block", width: "100%" }}>
                  <span className="borderGradian" onClick={onAddInhibition}>
                    <span
                      className="btnSecondary "
                      style={{ backgroundColor: "white", overflow: "visible" }}
                    >
                      <span className="textGradianlarge">
                        {i18next.t("ajouter une inhibition")}
                      </span>
                    </span>
                  </span>
                </p>
              </div>
            )}
            {visualizationCamera && (
              <div className="btn-explore">
                <Link className="btnSecondary" to={{ pathname: links }}>
                  <p style={{ display: "block", width: "100%" }}>
                    <span className="borderGradian">
                      <span
                        className="btnSecondary "
                        style={{
                          backgroundColor: "white",
                          overflow: "visible",
                        }}
                      >
                        <span className="textGradianlarge">
                          {i18next.t("visualizer les cameras")}
                        </span>
                      </span>
                    </span>
                  </p>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  onAddInhibition?: any;
  authorizationInibition?: boolean;
  message?: string;
  visualizationCamera?: boolean;
  links?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/message-inhibition/component.tsx